import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';

import EsmsModal from '../../components/EsmsModal';
import CancelButton from '../../components/CancelButton';
import ConfirmButton from '../../components/ConfirmButton';

import validator from '../../helpers/validator';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as BasAgentActions from '../../actions/basAgentActions';

import classes from './AssignAgentModal.module.css';

class AssignAgentModal extends Component {
    state = {
        formIsPopulated: false,
        formIsValid:     false,
        formControls:    {
            serialNumber: {
                value:           '',
                placeholder:     'Serial Number',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {
                    isBasSerialNumber: true
                }
            }
        }
    }

    resetModal = () => {
        const { serialNumber } = this.props.agent;
        const updatedControls = {
            ...this.state.formControls
        };

        const isPopulated = !!(serialNumber.trim && serialNumber.trim());

        updatedControls.serialNumber.value = (serialNumber.trim()) ? serialNumber : '';
        updatedControls.serialNumber.touched = isPopulated;
        updatedControls.serialNumber.valid = isPopulated;

        this.setState({
            formControls:    updatedControls,
            formIsPopulated: isPopulated,
            formIsValid:     isPopulated
        });
    }

    handleValidation = event => {
        const validatedState = validator(this.state, event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }

    handleChange = event => {
        const value = event.target.value;
        const name = event.target.name;

        const updatedControls = { ...this.state.formControls };

        updatedControls[name].value = value;

        this.setState({
            event:        { ...event },
            formControls: updatedControls
        });
    }

    handleUpdate = async () => {
        const updates = {
            serialNumber: this.state.formControls.serialNumber.value
        };
        const isUpdated = await this.props.updateBasAgent(this.props.companyInfo.companyId, this.props.agent.id, updates);

        if (isUpdated) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();

        this.props.close();
    }

    renderModalBodyText = agentName => {
        if (!this.state.formIsPopulated) {
            return (
                <p>
                    Please enter the Serial Number of the Hardware or Software BAS Agent you would like to assign to ${agentName}
                </p>
            );
        }

        return (
            <p>
                A BAS Agent Serial Number has already been assigned. To assign a new Serial Number, first Unassign Agent and then reassign via Assign Agent.
            </p>
        );
    }

    renderButtons = () => {
        if (!this.state.formIsPopulated) {
            return (
                <React.Fragment>
                    <CancelButton cancel={this.handleClose} />
                    <ConfirmButton
                        confirm={this.handleUpdate}
                        label="Assign"
                        type="button"
                        disabled={!this.state.formIsValid}
                    />
                </React.Fragment>
            );
        }

        return (
            <ConfirmButton
                confirm={this.handleClose}
                label="Close"
                type="button"
            />
        );
    }

    render() {
        let { agent, errors, open, title } = this.props;
        const agentName = agent.name;

        return (
            <EsmsModal
                errors={errors}
                imgSrc="/assets/images/basAgentIconColor.svg"
                open={open}
                onClose={this.handleClose}
                onRendered={this.resetModal}
                title={title}
            >
                {this.renderModalBodyText(agentName)}
                <FormControl className={classes.fullWidth}>
                    <InputLabel
                        className={classes.label}
                        htmlFor="serialNumber"
                        classes={{
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        {this.state.formControls.serialNumber.placeholder}
                    </InputLabel>
                    <Input
                        id="serialNumber"
                        name="serialNumber"
                        value={this.state.formControls.serialNumber.value}
                        disabled={this.state.formIsPopulated}
                        onChange={this.handleChange}
                        classes={{
                            underline: classes.cssUnderline,
                            root:      classes.input
                        }}
                        inputProps={{
                            onBlur: this.handleValidation
                        }}
                        endAdornment={
                            <InputAdornment
                                position="end"
                                className={classes.inputAdornment}
                            >
                                {
                                    !this.state.formIsValid &&
                                                   this.state.formControls.serialNumber.touched &&
                                                   <img src="/assets/images/removeIconRed.svg" alt="Incorrect" />
                                }
                                {
                                    this.state.formIsValid &&
                                                   this.state.formControls.serialNumber.touched &&
                                                   <img src="/assets/images/checkmarkIconGreen.svg" alt="Correct" />
                                }
                            </InputAdornment>
                        }
                    />
                    {!this.state.formControls.serialNumber.valid &&
                                  this.state.formControls.serialNumber.touched && <FormHelperText className={classes.error}>{this.state.formControls.serialNumber.message}</FormHelperText>}
                </FormControl>
                <div className={classes.buttonContainer}>
                    {this.renderButtons()}
                </div>
            </EsmsModal>
        );
    }
}

AssignAgentModal.propTypes = {
    agent: object.isRequired,
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        errors:      state.messages.errors
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignAgentModal);
